import type { UIEvent } from 'react';

import { ListComponents } from './components.styles';

import type { DataTracking } from 'core/middlewares/trackingGA4';

import { app } from 'core';
import type { UtilLinksProps } from './components.d';

export const UtilLinks = ({ data }: UtilLinksProps) => {
  const { trackClick } = app.commands.useAppCommand();

  const handleTrackClick = (event: UIEvent) => {
    const {
      currentTarget: { textContent },
    } = event;
    const trackData = {
      eventAction: 'clique:rodape',
      eventCategory: 'geral',
      eventLabel: textContent,
    } as DataTracking;

    trackClick(event, 'event', trackData);
  };

  const list = data?.map((item) => (
    <ListComponents.Li key={item.text}>
      <ListComponents.Link onClick={handleTrackClick} to={item.to}>
        {item.text}
      </ListComponents.Link>
    </ListComponents.Li>
  ));

  return <ListComponents.Ul>{list}</ListComponents.Ul>;
};
